import './App.css';
import Header from './components/Header.js';
import Hero from './components/Hero.js';
import Pricing from './components/Pricing.js';
import ContactHome from './components/ContactHome.js';
import Footer from './components/Footer.js';

function App() {
  return (
    <div>
      <Header />
      <Hero />
      <Pricing />
      <ContactHome />
      <Footer />
    </div>
  );
}

export default App;
